import React from "react";
import AppLayout from "@amzn/meridian/app-layout";
import Masthead, { MastheadMenuButton } from "@amzn/meridian/masthead";
import SideMenu from "@amzn/meridian/side-menu";
import {
  Button,
  Column,
  Icon,
  Link,
  Row,
  SearchField,
  Text,
} from "@amzn/meridian";
import DataTable, {
  DataTableBody,
  DataTableHeader,
  DataTableCell,
  DataTableRow,
  DataTableHead,
} from "@amzn/meridian/data-table";
import cogTokens from "@amzn/meridian-tokens/base/icon/cog";
import { INSPECTION_TABLE_HEADERS } from "src/constants/constants";
import { useNavigate } from "react-router-dom";
import AdminContents from "./adminContents";

const AdminLayout = () => {
  const navigate = useNavigate();
  return (
    <AppLayout
      headerComponent={Masthead}
      sidebarComponent={SideMenu}
      backgroundColor="alternateSecondary"
    >
      <Masthead>
        <Row alignmentHorizontal="justify" width={"100%"}>
          <Row>
            <MastheadMenuButton onClick={() => {}} open={true} />
            <Text>Safety Genie</Text>
          </Row>
        </Row>
      </Masthead>
      <Column spacingInset={"500 600"}>
        <Column spacingInset={"none 600"}>
          <AdminContents />
        </Column>
      </Column>
    </AppLayout>
  );
};

export default AdminLayout;
